/*********************
 * Header
 *********************/
export const LOGO_SIZE = 52;
export const LOGO_TEXT_SIZE = 64;

/*********************
 * Steps
 *********************/

export const STEPS_IDS = {
  LINK_ACCOUNTS: 'link-accounts',
} as const;

export const DEFAULT_STEP_INDEX = 0;
